import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieMessageComponent } from './cookie-message.component';
import { MaterialModule } from 'src/app/core/shared/util/material/material.module';



@NgModule({
  declarations: [
    CookieMessageComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [CookieMessageComponent]
})
export class CookieMessageModule { }
